import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ShoppingCartConfirmPaymentOnlinePlaceholder from 'components/ShoppingCart/Confirm/Payment/ShoppingCartConfirmPaymentOnlinePlaceholder';
import ShoppingCartConfirmPaymentOnlineComponent from 'components/ShoppingCart/Confirm/Payment/ShoppingCartConfirmPaymentOnlineComponent';
import { shoppingCartPaymentMethodsLoadAction } from 'view/ShoppingCart/Payment/Method/Load/ShoppingCartPaymentLoadAction';
import { shoppingCartPaymentMakeAction } from 'view/ShoppingCart/Confirm/Payment/Make/ShoppingCartPaymentMakeAction';
import ShoppingCartProduct from 'view/ShoppingCart/Product/ShoppingCartProduct';

export class ShoppingCartConfirmPaymentOnlineContainer extends Component {
    static propTypes = {
        load: PropTypes.func.isRequired,
        make: PropTypes.func.isRequired,
        token: PropTypes.string.isRequired,
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            email: PropTypes.string.isRequired,
        }).isRequired,
        products: PropTypes.arrayOf(PropTypes.instanceOf(ShoppingCartProduct))
            .isRequired,
    };

    state = {
        paymentMethods: null,
    };

    async componentDidMount() {
        await this.load();
    }

    load = async () => {
        const amount = this.props.products.reduce(
            (sum, product) => sum + product.sumPrice.amount,
            0
        );
        const paymentMethods = await this.props.load(amount);
        this.setState({ paymentMethods });
    };

    render() {
        return this.state.paymentMethods === null ? (
            <ShoppingCartConfirmPaymentOnlinePlaceholder />
        ) : (
            <ShoppingCartConfirmPaymentOnlineComponent
                make={this.props.make}
                token={this.props.token}
                products={this.props.products}
                paymentMethods={this.state.paymentMethods}
                user={this.props.user}
            />
        );
    }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    load: amount => shoppingCartPaymentMethodsLoadAction(amount),
    make: (token, method, channel, successUrl, cancelUrl) =>
        dispatch(
            shoppingCartPaymentMakeAction(
                token,
                method,
                channel,
                successUrl,
                cancelUrl
            )
        ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShoppingCartConfirmPaymentOnlineContainer);
